<template>
  <!-- 3 variants: closed (grey icon tile + "+"), open (isOpen: accent icon tile), chevron (rightIcon) -->
  <div
      :class="{ 'is-open': isOpen }"
      class="panel-heading d-flex align-items-center justify-content-between ">
    <div
        v-if="leftIcon"
        class="d-flex align-items-center">
      <div

          class="left-icon custom-icon">
        <icon :name="leftIcon"/>
      </div>
      <div class="widget-name p-0">{{ title }}</div>
    </div>
    <div
        v-if="rightIcon"
        :class="{ 'rotate-icon': isOpen && rightIcon === 'chevron' }"
        class="d-flex align-items-center">
      <icon :name="rightIcon"/>
    </div>
    <div
        v-tooltip="'Add New '+ section"
        v-else
        class="expand-icon-wrapper bg-white d-flex align-items-center justify-content-center custom-icon"
        @click.stop="onClickPlusButton(section)">
      <icon
          name="plus"
          class="custom-icon secondary-svg-icon plus-icon"/>

    </div>
  </div>
</template>
<script>
import LeftSectionPanelTypes from '@/mixins/LeftSectionPanelTypes';
import EventBus from '@/EventBus';
import Text from '@/components/DesignObjects/TextObject';
import { uuid } from 'vue-uuid';
import { getMaxZIndex, fetchingSvg, convertingDifferentMeasurementUnitIntoPx } from '@/components/Helper';
import DefaultImageProps from '@/components/DesignObjects/ImageObject';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import {
  FDIC_LOGO_BLACK_SVG,
  FDIC_TEXT_BLACK_SVG,
  NCUA_TEXT_BLACK_SVG,
  FDIC_LOGO_2_BLACK_SVG,
} from '@/library/LogosSvgHelper';

export default {
  name:  'PanelHeading',
  mixin: [LeftSectionPanelTypes.Mixin],
  props:
      {
        title:               String,
        leftIcon:            String,
        section:             String,
        details:             Boolean,
        twitterPost:         Boolean,
        rightIcon:           String,
        isOpen:              Boolean,
        productWidth:        Number,
        productHeight:       Number,
        ProductAddressBoxes: {
          default: null,
        },
      },
  data() {
    return { isArrowRotated: false };
  },
  computed: {
    getProductAddressBoxes() {
      if (this.ProductAddressBoxes) {
        return this.ProductAddressBoxes[0];
      }
    },
  },
  methods: {
    async onClickPlusButton(section) {
      if (section == LeftSectionPanelTypes.TEXT) {
        EventBus.$emit('pauseVideoOnOutsideClick');
        const fontSize               = Math.max(12, Math.max(this.productWidth, this.productHeight) * 0.02);
        const { data }               = new Text();
        const textWidth              = this.productWidth <= 125 ? 80 : 160;
        const textHeight             = 30;
        data.fontFamily              = 'Arial';
        data.fontSize                = fontSize;
        data.X                       = Math.abs((this.productWidth / 2) - textWidth / 2);
        data.Y                       = Math.abs((this.productHeight / 2) - textHeight / 2);
        data.Width                   = textWidth;
        data.Height                  = textHeight;
        data.elementIndex            = 0;
        data.lineHeight              = 1.2;
        data.objectId                = uuid.v1();
        data.Id                      = data.objectId;
        data.isTextAdjustmentsNeeded = false;
        data.isSelected              = false;
        data.color                   = '#000000';
        data.Value                   = '<span>Enter Text Here</span>';
        data.PdfSortOrder            = data.SortOrder = getMaxZIndex(document.getElementById('canvas-wrapper').firstElementChild.children) + 1;
        EventBus.$emit('onObjectAdding', JSON.parse(JSON.stringify(data)));
      } else if (section == LeftSectionPanelTypes.Image) {
        EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED);
        this.$store.commit('toggleIsAddNewImageModal');
      }
      if (section == LeftSectionPanelTypes.Video) {
        EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED);
        this.$store.commit('setDisplayAddVideoModal', true);
      }
      if (section == LeftSectionPanelTypes.FDIC) {
        /*
        const fdicLogos = this.$store.getters.getFdicLogos;

        let blackLogo = 'https://pdf-processing.bankmarketingcenter.com/svg/fdictext-pdf.svg';
        try {
          if (fdicLogos.length > 0 && fdicLogos[0].DefaultImagePath.length > 0) {
            blackLogo = fdicLogos[0].DefaultImagePath;
          }
        } catch (e) {
          console.log('FDIC logo missing');
        }
        const { data }       = new DefaultImageProps();
        const objectHeight   = 33;
        const objectWidth    = 57;
        data.ImageType       = 'FDICText';
        data.DefaultImageUrl = blackLogo;
        data.HighResPath     = blackLogo;
        data.Name            = 'FDIC';
        data.id              = data.Id = uuid.v1();
        data.PdfSortOrder    = data.SortOrder = getMaxZIndex(document.getElementById('canvas-wrapper').firstElementChild.children) + 1;
        data.Width           = objectWidth;
        data.Height          = objectHeight;
        data.elementIndex    = 0;
        data.isSelected      = false;
        data.RotateDegree    = 0;
        data.X               = Math.abs((this.productWidth / 2) - objectWidth / 2);
        data.Y               = Math.abs((this.productHeight / 2) - objectHeight / 2);
        EventBus.$emit('onObjectAdding', JSON.parse(JSON.stringify(data)));
        */

        const blackLogo = 'https://pdf-processing.bankmarketingcenter.com/svg/fdictext-pdf.svg';
        // const shapeInput = await fetchingSvg(blackLogo);
        const shapeInput = FDIC_TEXT_BLACK_SVG;

        const style        = `style="transform-origin: left top; transform: scale(${1}, ${1});"`;
        shapeInput.content = shapeInput.content.includes('style="transform-origin: left top 0px;"') ? shapeInput.content.replace('style="transform-origin: left top 0px;"', style) : shapeInput.content.replace('style="transform-origin: left top;"', style); // check for the browser compatibility
        EventBus.$emit('AddSvgShape', {
          content:   shapeInput.content,
          name:      'FDIC',
          color:     'rgb(0,0,0)',
          width:     convertingDifferentMeasurementUnitIntoPx(shapeInput.width),
          height:    convertingDifferentMeasurementUnitIntoPx(shapeInput.height),
          ImageType: 'FDICText',
        });
      }
      if (section == LeftSectionPanelTypes.NCUA) {
        /*
        const ncuaLogos = this.$store.getters.getNcuaLogos;
        let blackLogo   = 'https://pdf-processing.bankmarketingcenter.com/svg/ncualogocreditUnion-pdf.svg';
        try {
          if (ncuaLogos.length > 0 && ncuaLogos[0].DefaultImagePath.length > 0) {
            blackLogo = ncuaLogos[0].DefaultImagePath;
          }
        } catch (e) {
          console.log('FDIC logo missing');
        }
        const { data }       = new DefaultImageProps();
        const objectHeight   = 33;
        const objectWidth    = 57;
        data.ImageType       = 'FDICText';
        data.DefaultImageUrl = blackLogo;
        data.HighResPath     = blackLogo;
        data.Name            = 'NCUA';
        data.id              = data.Id = uuid.v1();
        data.PdfSortOrder    = data.SortOrder = getMaxZIndex(document.getElementById('canvas-wrapper').firstElementChild.children) + 1;
        data.Width           = objectWidth;
        data.Height          = objectHeight;
        data.elementIndex    = 0;
        data.isSelected      = false;
        data.RotateDegree    = 0;
        data.X               = Math.abs((this.productWidth / 2) - objectWidth / 2);
        data.Y               = Math.abs((this.productHeight / 2) - objectHeight / 2);
        EventBus.$emit('onObjectAdding', JSON.parse(JSON.stringify(data)));
        */
        const blackLogo = 'https://pdf-processing.bankmarketingcenter.com/svg/protectedarea/images/202308/ncualogocreditUnion0823_updated033.svg';
        // const shapeInput = await fetchingSvg(blackLogo);
        const shapeInput = NCUA_TEXT_BLACK_SVG;

        const style        = `style="transform-origin: left top; transform: scale(${1}, ${1});"`;
        shapeInput.content = shapeInput.content.includes('style="transform-origin: left top 0px;"') ? shapeInput.content.replace('style="transform-origin: left top 0px;"', style) : shapeInput.content.replace('style="transform-origin: left top;"', style); // check for the browser compatibility
        EventBus.$emit('AddSvgShape', {
          content:   shapeInput.content,
          name:      'NCUA',
          color:     'rgb(0,0,0)',
          width:     convertingDifferentMeasurementUnitIntoPx(shapeInput.width),
          height:    convertingDifferentMeasurementUnitIntoPx(shapeInput.height),
          ImageType: 'FDICText',
        });
      }
      if (section === LeftSectionPanelTypes.HOUSING) {
        /*
        const housingLogos = this.$store.getters.getHousingLogos;
        let blackLogo      = 'https://pdf-processing.bankmarketingcenter.com/svg/fdiclogo-pdf.svg';
        try {
          if (housingLogos.length > 0 && housingLogos[0].DefaultImagePath.length > 0) {
            blackLogo = housingLogos[0].DefaultImagePath;
          }
        } catch (e) {
          console.log('housing logo missing');
        }

        const { data }       = new DefaultImageProps();
        const objectHeight   = 49;
        const objectWidth    = 44;
        data.ImageType       = 'FDICLogo'; // Equal Housing type is FDIC Logo in case of black color
        data.DefaultImageUrl = blackLogo;
        data.HighResPath     = blackLogo;
        data.Name            = 'Equal Housing';
        data.id              = data.Id = uuid.v1();
        data.PdfSortOrder    = data.SortOrder = getMaxZIndex(document.getElementById('canvas-wrapper').firstElementChild.children) + 1;
        data.Width           = objectWidth;
        data.Height          = objectHeight;
        data.elementIndex    = 0;
        data.isSelected      = false;
        data.RotateDegree    = 0;
        data.X               = Math.abs((this.productWidth / 2) - objectWidth / 2);
        data.Y               = Math.abs((this.productHeight / 2) - objectHeight / 2);
        EventBus.$emit('onObjectAdding', JSON.parse(JSON.stringify(data)));
        */

        const housingLogos = this.$store.getters.getHousingLogos;
        let blackLogo      = 'https://pdf-processing.bankmarketingcenter.com/svg/fdiclogo-pdf.svg';
        try {
          if (housingLogos.length > 0 && housingLogos[0].DefaultImagePath.length > 0) {
            blackLogo = housingLogos[0].DefaultImagePath;
          }
        } catch (e) {
          console.log('housing logo missing');
        }

        const shapeInput = await fetchingSvg(blackLogo);
        // const shapeInput = blackLogo.indexOf('EOL') === -1 ? FDIC_LOGO_BLACK_SVG : FDIC_LOGO_2_BLACK_SVG;

        const style        = `style="transform-origin: left top; transform: scale(${1}, ${1});"`;
        shapeInput.content = shapeInput.content.includes('style="transform-origin: left top 0px;"') ? shapeInput.content.replace('style="transform-origin: left top 0px;"', style) : shapeInput.content.replace('style="transform-origin: left top;"', style); // check for the browser compatibility

        let counter   = 1;
        const clipMap = {};

        // Replace clipPath ids to ensure uniqueness
        shapeInput.content = shapeInput.content.replace(/<clipPath\s+id="(.*?)"/g, (_, oldId) => {
          const newId    = `clip_new_${counter++}`;
          clipMap[oldId] = newId;
          return `<clipPath id="${newId}"`;
        });

        // Replace all clip-path="url(#...)" references
        shapeInput.content = shapeInput.content.replace(/clip-path="url\(#(.*?)\)"/g, (_, oldId) => {
          const newId = clipMap[oldId] || oldId;
          return `clip-path="url(#${newId})"`;
        });

        // (Optional) Replace references inside style="clip-path:url(#...);" if needed
        shapeInput.content = shapeInput.content.replace(/clip-path:\s*url\(#(.*?)\)/g, (_, oldId) => {
          const newId = clipMap[oldId] || oldId;
          return `clip-path:url(#${newId})`;
        });

        EventBus.$emit('AddSvgShape', {
          content:   shapeInput.content,
          name:      'Equal Housing',
          color:     'rgb(0,0,0)',
          width:     convertingDifferentMeasurementUnitIntoPx(shapeInput.width),
          height:    convertingDifferentMeasurementUnitIntoPx(shapeInput.height),
          ImageType: 'FDICLogo',
        });
      }
      if (section == LeftSectionPanelTypes.ADDRESS) {
        EventBus.$emit('pauseVideoOnOutsideClick');
        const { data }       = new DefaultImageProps();
        data.ImageType       = 'WhiteboxLogo';
        data.DefaultImageUrl = this.getProductAddressBoxes.DefaultImagePath;
        data.HighResPath     = this.getProductAddressBoxes.HighResImagePath;
        data.Name            = 'Address Box';
        data.objectId        = data.Id = uuid.v1();
        data.PdfSortOrder    = data.SortOrder = getMaxZIndex(document.getElementById('canvas-wrapper').firstElementChild.children) + 1;
        data.elementIndex    = 0;
        data.isSelected      = false;
        data.RotateDegree    = 0;

        const img  = new Image();
        img.onload = () => {
          data.DefaultImageHeight = img.height;
          data.DefaultImageWidth  = img.width;
          const heightRatio       = img.height / img.width;
          data.Width              = this.productWidth / 1.5;
          data.Height             = Math.round(data.Width * heightRatio);
          data.X                  = Math.abs((this.productWidth / 2) - data.Width / 2);
          data.Y                  = Math.abs((this.productHeight / 2) - data.Height / 2);
          EventBus.$emit('onObjectAdding', JSON.parse(JSON.stringify(data)));
        };

        img.src = this.getProductAddressBoxes.DefaultImagePath;
      }
      if (section == LeftSectionPanelTypes.QRCODE) {
        EventBus.$emit('pauseVideoOnOutsideClick');
        this.$store.commit('setDisplayQRCodeModal', true);
      }
      if (section == LeftSectionPanelTypes.Audio) {
        EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED);
        this.$store.commit('setDisplayAddAudioModal', true);
      }
      if (section == LeftSectionPanelTypes.TABLE) {
        EventBus.$emit('addTableFromPanel');
      }
      EventBus.$emit(ApplicationEventTypes.Canvas.CANVAS_RE_RENDER);
    },
  },
};

</script>
<style lang="scss">
@import '../LeftSection/styles/lp-tokens';

.main-panel-wrapper {
  .widget-name {
    @include FontVariation($lp-fs-title, 600, $lp-sans, $lp-ink);
    display: block;
    line-height: 20px;
  }

  .left-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    margin-right: 12px;
    border-radius: 10px;
    background-color: $lp-fill;
    color: $lp-ink-2;
    transition: background-color 0.15s, color 0.15s;
  }

  // Open variant: accent icon tile
  .panel-heading.is-open .left-icon {
    background-color: $lp-accent;
    color: $white;

    svg [stroke]:not([stroke="none"]) {
      stroke: currentColor;
    }

    svg [fill]:not([fill="none"]) {
      fill: currentColor;
    }
  }

  // Chevron variant
  .panel-heading .right-icon {
    width: 28px;
    height: 28px;
    transition: transform 0.2s;
  }

  .expand-icon-wrapper {
    height: 28px;
    width: 28px;
    border: 1px solid $lp-line;
    border-radius: 8px;

    svg {
      height: 12px;
      width: 12px;

      path {
        stroke: $lp-ink-2;
      }
    }

    &:hover {
      border-color: $lp-accent;
      background-color: $lp-accent !important;
    }

    &:hover svg path {
      stroke: $white;
    }
  }
}

.collapsed {
  .minus-icon {
    display: block !important;
  }
}

.expand-icon-wrapper {
  height: 16px;
  width: 16px;
  cursor: pointer;

  &:hover {
    background-color: $blue60 !important;
  }
}

.secondary-svg-icon {
  min-height: 0 !important;
  min-width: 0 !important;
}

.secondary-svg-icon {
  svg {
    height: 10px;
    width: 10px;
  }
}


</style>
